// this file origin from Winningtemp.Shared

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Colors from "Colors";

const SmileyWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ${props => props.isReadOnly ? "" : "pointer"};
    border-radius: 2px;
    width: ${props => props.size || "46px"};
    min-width: ${props => props.size || "46px"};
    height: ${props => props.size || "46px"};
    background-color: ${props => props.isActive ? Colors.backgroundLightBlue : Colors.white};
    border: ${props => props.isActive ? props.activeBorder : `1px solid ${Colors.grey86}`};
    margin: ${props => props.margin || "0"};
    ${props => props.isReadOnly ? "" : 
        `&:hover {
            border-color: ${props.isActive ? props.hoverBorder || Colors.mainBlue : Colors.grey70};
            background-color: ${props.isActive ? Colors.backgroundLightBlue : Colors.backgroundLightGray};
        }`
    }
    @media(max-width: 768px) {
        ${props => props.sizeXS ? `width: ${props.sizeXS}; min-width: ${props.sizeXS}; height: ${props.sizeXS};` : ""}
    }
    @media(max-width: 360px) {
        width: 38px;
        min-width: 38px;
        height: 38px;
    }
`;

SmileyWrapper.propTypes = {
    isActive: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    size: PropTypes.string,
    sizeXS: PropTypes.string,
    margin: PropTypes.string,
    activeBorder: PropTypes.string,
    hoverBorder: PropTypes.string,
}

export default SmileyWrapper;